<template>
    <temp-ranking-management :eventId="eventId">

    </temp-ranking-management>
</template>

<script>
    import TempRankingManagement from '../../components/dynamic/ranking/TempRankingManagement';

    export default {
        components: {
            TempRankingManagement
        },
        data() {
            return {
                eventId: 81
            }
        },
        methods: {

        }
    }
</script>

<style scoped>
</style>
